import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/financeiro/moedas${queryUrl}`)
  },
  insertNewMoeda(data) {
    return axios.post('/financeiro/moedas', data)
  },
  editMoeda(data) {
    return axios.put(`/financeiro/moedas/${data.id}`, data)
  },
  deleteMoeda(id) {
    return axios.delete(`/financeiro/moedas/${id}`)
  },
}
